import React from "react";

export function TextInput(props) {

    return (
            <label className={props.className} onClick={props.onClick}>{props.text}</label>
    )
}
